<header>
  <nav class="bg-white border-gray-200 py-3 dark:bg-gray-800 shadow-md w-full z-50 min-h-[74px] top-0"
    [ngClass]="position">
    <div class="mx-auto w-full max-w-7xl px-1">
      <div class="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl">
        <a class="flex items-center text-primary-500 px-4 bg-white rounded-full" *ngIf="companyInfo">
          <img onclick="window.location.href = '/'" [src]="'assets/icons/g-icon.svg'" class="ltr:mr-3 rtl:ml-3  h-9 " alt="Glamera" />
          <!-- <span *ngIf="companyInfo" class="hidden md:block text-primary-700 font-bold">
            {{
            translate.currentLang === "en"
            ? companyInfo.nameEn
            : companyInfo.nameAr
            }}
          </span> -->
        </a>
        <div class="flex align-items-center lg:order-2">
          <app-lang-dropdwon class="hidden lg:inline-block"></app-lang-dropdwon>
          @if (common.isLoggedIn()) {
          <div class="flex justify-center items-center mx-4 cursor-pointer" routerLink="/booking/items">
            <div class="relative">
              <div class="t-0 absolute left-3" *ngIf="cart?.itemsCount">
                <p class="flex h-2 w-2 items-center justify-center rounded-full bg-red-500 p-3 text-xs text-white">{{cart?.itemsCount}}</p>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="file: mt-4 h-6 w-6">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
              </svg>
            </div>
          </div>
          <div ngbDropdown #topMenu="ngbDropdown" placement="bottom-end" class="hidden md:inline-block text-black">
            <div ngbDropdownToggle
              class="flex align-items-center h-10 hover:bg-gray-100 hover:text-black rounded-full pe-[1.25rem] cursor-pointer after:hidden"
              [ngClass]="topMenu.isOpen() ? 'bg-gray-100' : ''">
              <div class="flex align-items-center h-full w-10 text-center rounded-full overflow-hidden ">
                <div class="w-full flex items-center justify-center ">
                  <ng-container *ngIf="(clientDetails$ | async) as client">
                    <ng-container *ngIf="client.basicInfo.imagePath; else noImage">
                      <img loading="lazy"  [src]="client.basicInfo.imagePath" class="w-full h-full object-cover" />
                    </ng-container>
                  </ng-container>
                  <ng-template #noImage>
                    <i class="fa-solid fa-user-tie fa-xl"></i>
                  </ng-template>
                </div>
              </div>

              <div>
                <span class="hidden md:inline-block ms-2">
                  {{ common.isLoggedIn() ? common.getUserName() : "" }}
                </span>
              </div>
              <i class="fa-solid fa-angle-down ms-[.5rem]"></i>
            </div>
            <div ngbDropdownMenu (click)="topMenu.close()"
              class="mt-1 ltr:right-0 rtl:left-0 border-gray-100 bg-white shadow min-w-fit w-52 text-sm [&_a]:text-start [&_a]:block [&_a]:text-gray-950 [&_a]:cursor-pointer [&_a]:px-6 [&_a]:py-2 [&_a:hover]:bg-gray-100">
              <a *ngIf="common.isLoggedIn()" routerLink="/booking/profile">
                {{ "menu.viewProfile" | translate }}
              </a>
              <a [routerLink]="['resources', 'terms-and-conditions']">
                {{ "menu.termsAndConditions" | translate }}
              </a>
              <!-- <a [routerLink]="['resources', 'about-us']">
                {{ "menu.aboutUs" | translate }}
              </a> -->
              <a [routerLink]="['resources', 'return-policy']">
                {{ "menu.returnPolicy" | translate }}
              </a>
              <a *ngIf="common.isLoggedIn()" (click)="logout()">
                <span class="text-red-500">
                  <i class="fa-solid fa-arrow-right-from-bracket"></i>
                  {{ "menu.logout" | translate }}
                </span>
              </a>
            </div>
          </div>
          <button class="cursor-pointer" (click)="isMenu = true"
            class="show-menu text-white md:hidden hover:bg-gray-100 p-2 rounded-md">
            <div class="flex align-items-center h-full w-10 text-center rounded-full overflow-hidden">
              <div class="w-full h-8 flex items-center justify-center">
                <ng-container *ngIf="(clientDetails$ | async) as client">
                  <ng-container *ngIf="client.basicInfo.imagePath; else noImage">
                    <img loading="lazy"  [src]="client.basicInfo.imagePath" class="w-full h-full object-cover" />
                  </ng-container>
                </ng-container>
                <ng-template #noImage>
                  <i class="fa-solid fa-user-tie fa-xl"></i>
                </ng-template>
              </div>
            </div>
          </button>
          } @else {
          <a href="javascript:void(0)" routerLink="login"
            class="hidden lg:inline-block text-primary-500 mx-2 ring-1 group ring-primary-500 transition duration-300 hover:bg-primary-500 hover:text-white font-medium rounded-full  text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 ">
            <span class="ltr:mr-3 rtl:ml-3 text-nowrap">{{ "menu.login" | translate }}</span>
            <i class="fa text-primary-500 group-hover:text-white transition duration-300"
              [class]="common.getLang() == 'ar' ? 'fa-arrow-left-long' : 'fa-arrow-right-long'"></i>
          </a>
          }
          <button data-collapse-toggle="mobile-menu-2" type="button" (click)="isHeader = true"
            class="inline-flex items-center p-2 ml-1 text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100"
            aria-controls="mobile-menu-2" aria-expanded="false">
            <span class="sr-only">Open main menu</span>
            <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd"
                d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                clip-rule="evenodd"></path>
            </svg>
            <svg class="hidden w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"></path>
            </svg>
          </button>
          <app-lang-dropdwon class="hidden lg:inline-block"></app-lang-dropdwon>

        </div>
        <div class="hidden justify-between items-center w-full lg:flex lg:w-auto lg:order-1 mx-auto" id="mobile-menu-2">
          <ul class="flex flex-col my-0 py-0 font-medium lg:flex-row lg:space-x-8 justify-center">
            <li class="my-0 mx-2">
              <a href="/" class="block py-2 pr-4 pl-3 text-gray-700"
                [ngClass]="{ 'border-b border-primary-700 text-primary-700': currentSection == 'home' }"
               >{{'links.home' | translate}}</a>
            </li>
            <li class="my-0 mx-2" [routerLink]="['resources', 'about-us']">
              <a href="javascript:void(0)" [routerLinkActive]="'border-b border-primary-700 text-primary-700'"
                class="block py-2 pr-4 pl-3 text-gray-700 ">{{'links.aboutUs' | translate}}</a>
            </li>
            <li class="my-0 mx-2" (click)="navigate('/','services')">
              <a href="javascript:void(0)"
                [ngClass]="{ 'border-b border-white text-white': (currentSection == 'services' && !isFilterService) }"
                class="block py-2 pr-4 pl-3 text-white ">{{'links.ourServices' | translate}}</a>
            </li>
            <li class="my-0 mx-2">
              <a href="javascript:void(0)" class="block py-2 pr-4 pl-3 text-gray-700 " routerLink="branches"
                [routerLinkActiveOptions]="{exact: true}"
                routerLinkActive="border-b border-primary-700 text-primary-700">{{'links.ourBranches' | translate}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</header>
<p-sidebar [(visible)]="isMenu" [showCloseIcon]="true" styleClass="w-full sm:w-2/3" position="right" [modal]="true"
  [baseZIndex]="10000">
  <ng-container *ngIf="isMenu">
    <app-menu [clientDetails$]="clientDetails$" (onLogout)="logout()" (onCloseMenu)="isMenu = false"></app-menu>
  </ng-container>
</p-sidebar>

<p-sidebar [(visible)]="isHeader" [showCloseIcon]="true" styleClass="w-full sm:w-2/3" position="right" [modal]="true"
  [baseZIndex]="10000">
  <ng-container *ngIf="isHeader">
    <aside class="w-full h-100vh" aria-label="Sidebar">
      <div class="overflow-y-auto rounded bg-gray-50 h-full py-5">
        <ul class="space-y-2 m-0 p-0">
          <li>
            <a href="javascript:void(0)" (click)="navigate('/','home');isHeader = false"
              class="flex items-center p-3 text-base font-normal text-gray-900 hover:bg-primary-300 ">
              <span class="flex-1 ml-3 whitespace-nowrap">{{'links.home' | translate}}</span>
              <span class="inline-flex items-center justify-center px-2 ml-3 text-sm font-medium text-gray-800">
                <i class="fa" [class]="translate.currentLang == 'en' ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
              </span>
            </a>
          </li>
          <li>
            <a href="javascript:void(0)" (click)="navigate('/resources/about-us');isHeader = false"
              class="flex items-center p-3 text-base font-normal text-gray-900 hover:bg-primary-300 ">
              <span class="flex-1 ml-3 whitespace-nowrap">{{'links.aboutUs' | translate}}</span>
              <span class="inline-flex items-center justify-center px-2 ml-3 text-sm font-medium text-gray-800">
                <i class="fa" [class]="translate.currentLang == 'en' ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
              </span>
            </a>
          </li>
          <li>
            <a href="javascript:void(0)" (click)="navigate('/','services');isHeader = false"
              class="flex items-center p-3 text-base font-normal text-gray-900 hover:bg-primary-300 ">
              <span class="flex-1 ml-3 whitespace-nowrap">{{'links.ourServices' | translate}}</span>
              <span class="inline-flex items-center justify-center px-2 ml-3 text-sm font-medium text-gray-800">
                <i class="fa" [class]="translate.currentLang == 'en' ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
              </span>
            </a>
          </li>
          <li>
            <a href="javascript:void(0)" (click)="navigate('branches')"
              class="flex items-center p-3 text-base font-normal text-gray-900 hover:bg-primary-300 ">
              <span class="flex-1 ml-3 whitespace-nowrap">{{'links.ourBranches' | translate}}</span>
              <span class="inline-flex items-center justify-center px-2 ml-3 text-sm font-medium text-gray-800">
                <i class="fa" [class]="translate.currentLang == 'en' ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
              </span>
            </a>
          </li>
          <li>
            <a href="javascript:void(0)" (click)="isCollapsed = !isCollapsed"
              class="flex items-center p-3 text-base font-normal text-gray-900 hover:bg-primary-300 ">
              <span class="flex-1 ml-3 whitespace-nowrap">{{'language' | translate}}</span>
              <span class="inline-flex items-center justify-center px-2 ml-3 text-sm font-medium text-gray-800">
                <i class="fa" [class]="translate.currentLang == 'en' ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
              </span>
            </a>
            <div [ngClass]="{ 'max-h-0': !isCollapsed, 'max-h-auto': isCollapsed }"
              class="max-h-0 overflow-hidden transition-all duration-300 ease-in-out">
              <div class="pb-2 text-sm text-slate-500">
                <div
                  class="mt-2 ltr:right-0 rtl:left-0 border-gray-100 bg-white shadow min-w-fit w-full text-[13px] [&_button]:text-start [&_button]:block [&_button]:w-full [&_button]:px-6 [&_button]:py-2 [&_button:hover]:bg-gray-100">
                  <button (click)="changeLanguage('ar');" [disabled]="translateService.currentLang === 'ar'"
                    [ngClass]="{'text-gray-400': translateService.currentLang === 'ar'}">
                    {{ 'ArabicInArabic' | translate }}
                  </button>
                  <button (click)="changeLanguage('en');" [disabled]="translateService.currentLang === 'en'"
                    [ngClass]="{'text-gray-400': translateService.currentLang === 'en'}">
                    {{ 'EnglishInEnglish' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </li>
          <li *ngIf="!common.isLoggedIn()">
            <a href="javascript:void(0)" (click)="logIn()"
              class="flex items-center p-3 text-base font-normal text-green-600 hover:bg-primary-300 ">
              <span class="flex-1 ml-3 whitespace-nowrap">{{ "menu.login" | translate }}</span>
              <span class="inline-flex items-center justify-center px-2 ml-3 text-sm font-medium text-gray-800">
                <i class="fa" [class]="translate.currentLang == 'en' ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
              </span>
            </a>
          </li>
        </ul>
      </div>
    </aside>
  </ng-container>
</p-sidebar>